export default __webpack_public_path__ + "static/media/stepBlogger-4.22dd407a.svg";